import { useEffect, useState } from "react";
import secureLocalStorage    from "react-secure-storage";

import {
  get_feed_state,
  get_product_state } from '../utils/FeedInterface';

import {
  get_euro_value,
  get_now_time,
  get_time_passed }   from '../utils/utils';

export default function useFeed (  )
{
  // TODO update offset will be gotten by db settings.
  const FEED_REFRESH = ( 1000 * 60 ) * 20 ; // 20 minutes updates.

  /* 2026 :: WIP
   * price update timer.
   * time will be setup using the service last update datetime
   * in the best case scenario */
  const [ timer, set_timer ] = useState( '00 : 00' );
  const [ feed, set_current_feed ] = useState({  }); // feed container.
  const [ error, set_error ] = useState({  });




  useEffect( () => {
    // start interval
    fetch_feed(); // fetch feed from server.
    let tt = setInterval(() => {

      console.log( 'feed ticking...' );
      fetch_feed(); // fetch feed from server.

    }, FEED_REFRESH );

    // stop timer on component exit.
    // avoid timer start loops.
    return () => {
      clearInterval( tt );
    };
  }, [  ] );

  return { feed, error };




  /* 2026 :: WIP
   * functions
   */

  function fetch_feed (  )
  {
    get_feed_state( ).then( re => {
      // feed data distillation
      let usefulFeed = {};

      usefulFeed.STATE = re.STATE;
      usefulFeed.SERVICE = re.SERVICE;
      usefulFeed.FIX = re.FIX;
      usefulFeed.UPDATE = re.UPDATE;
      usefulFeed.LAST_UPDATE = re.last_update;
      console.log( 'last price write', re.last_update );
      usefulFeed.USD = parseFloat( re.USD );

      usefulFeed.XAU_RAW = parseFloat( re.XAU );
      usefulFeed.XAU = get_euro_value( parseFloat( re.XAU ), parseFloat( re.USD ) );
      usefulFeed.XAUPAC = get_euro_value( parseFloat( re.XAU ), parseFloat( re.USD ) );

      usefulFeed.XAG_RAW = parseFloat( re.XAG );
      usefulFeed.XAG = get_euro_value( parseFloat( re.XAG ), parseFloat( re.USD ) );
      usefulFeed.XAGPAC = get_euro_value( parseFloat( re.XAG ), parseFloat( re.USD ) );

      // store current feed on storage
      usefulFeed.LOCAL_UPDATE = get_now_time();

      // set feed data
      set_current_feed( usefulFeed );
      secureLocalStorage.setItem( 'feed', usefulFeed );

    }).catch( err => {
      set_error( err );
    });
  }

}
